export default entity => {
  const { title, identifier } = entity;
  const userFriendlyId = identifier ? `#${identifier}` : identifier;
  let name = '';
  if (userFriendlyId) {
    name += `${userFriendlyId} - `;
  }
  name += title;
  return name;
};
